
export const GET_CURRENT_ID = state => state.currentId;

export const GET_LOAD_ANIMATE = state => state.animatedLoad;

export const GET_UI_SHOW = state => state.uiShow;

export const GET_HANDLE = state => state.handleBlock;

export const GET_POPUP = state => state.popup.name;

export const GET_POPUP_DATA = state => state.popup;

export const GET_URL_ROOT = state => state.urlRoot;

export const GET_QUEST = state => state.quest;

export const GET_ANIMATED = state => state.animated;



// WEBPACK FOOTER //
// ./src/store/getters.js